import AddGridItemButton from "app/WebController/Component/Buttons/Layout/AddGridItemButton"
import React from "react"

function ToolbarLayoutController() {

  return (
    <>
      <AddGridItemButton/>
    </>

  )
}

export default ToolbarLayoutController
